export const data = [
    {
    id: 1,
    title: 'Женская политшкола',
    content: (st)=> `
        <div class="${st.content}">
            <div class="${st.content_item}">
                <h4>Женская политшкола</h4>
                <p>
                    Проведение очных и онлайн образовательных программ: лекций, тренингов и мастер-классов с политологами, политтехнологами, 
                    социологами и экспертами. Разбор практических задач и успешных кейсов. Программа обучения проходит в сотрудничестве с 
                    Высшей партийной школой
                </p>
            </div>
            <div class="${st.content_item}">
                <h4>Наставничество</h4>
                <p>
                    Сопровождение женщин-кандидатов всех уровней без политического опыта и баллотирующихся впервые. 
                    Наставницы направления – лидеры общественного мнения регионального уровня с опытом политической работы, 
                    в том числе действующие депутаты, депутаты ГД ФС РФ, сенаторы ФС РФ. Проект реализуется в сотрудничестве 
                    с Центральным исполкомом «Единой России», кадровым проектом партии «ПолитСтарт»
                </p>
                <p>
                    Наставничество для студентов. Синхронизация проекта Минобрнауки «Женщина. Школа наставничества», Школы академического 
                    наставничества и «Женского движения Единой России». Вовлечение в движение девушек-студенток, 
                    которые занимают активную гражданскую позицию и стремятся к саморазвитию. Проект реализуется в пилотных регионах: 
                    Курской, Белгородской, Воронежской, Нижегородской и Ростовской областях
                </p>
            </div>
            <div class="${st.content_item}">
                <h4>Законодательство</h4>
                <p>
                    Совершенствование законодательной среды и адаптация к существующим реалиям с учетом изменений 
                    в обществе, ориентированных на улучшение жизни человека. Создание рабочих групп, проведение круглых 
                    столов по обсуждению законодательных инициатив при участии структур и ведомств, заинтересованных 
                    в совершенствовании правового регулирования
                </p>
            </div>
        </div>
    `
  },
    {
        id: 2,
        title: 'Женское предпринимательство',
        content: (st)=> `
        <div class="${st.content}">
            <div class="${st.content_item}">
                <h4>Женские клубы</h4>
                <p>
                    Организация клубов совместно с Министерством труда и социальной защиты РФ во всех регионах страны для оказания помощи в профессиональном обучении, трудоустройстве и самореализации, содействие в социальных вопросах, связанных с детьми
                </p>
            </div>
            <div class="${st.content_item}">
                <h4>Женское предпринимательство</h4>
                <p>
                    Проведение открытых площадок, встреч для представителей МСП с привлечением профильных ведомств
                    и экспертов, консультирование и сопровождение по вопросам открытия бизнеса, работа с семьями военнослужащих по ведению бизнеса на время мобилизации
                </p>
                <p>
                    Создание коммуникативных площадок для представителей малого и среднего бизнеса с привлечением профильных ведомств и экспертов
                </p>
                <p>
                    Реализация программы «Агромама». Образовательная и консультационная помощь в выборе направления бизнеса
                    и определении государственных мер поддержки, подготовка бизнес-планов, в том числе на участие в грантовых программах
                </p>
                <p>
                    Учреждение совместного с Минэкономразвития конкурса «Мой добрый бизнес», в рамках которого были отобраны 
                    и награждены грантами (спонсорские средства) лучшие социальные и семейные предприятия
                </p>
            </div>
        </div>
    `
    },
    {
        id: 3,
        title: 'Женское здоровье',
        content: (st)=> `
        <div class="${st.content}">
            <div class="${st.content_item}">
                <p>
                    Проект направлен на сохранение здоровья женщин всех возрастов
                </p>
                <p>
                    Предоставление женщинам полной, достоверной и понятной информации о профилактике заболеваний 
                    и ведении здорового образа жизни
                </p>
                <p>
                    Привлечение ведущих врачей, представителей медицинского и научного сообщества к встречам, 
                    семинарам, вебинарам
                </p>
            </div>
        </div>
    `
    },
    {
        id: 4,
        title: 'Социально-гуманитарное',
        content: (st)=> `
        <div class="${st.content}">
            <div class="${st.content_item}">
                <p>
                    Сотрудничество с организациями, оказывающими помощь СВО в рамках гуманитарной миссии: плетение маскировочных сетей, пошив изделий для нужд СВО, производство окопных свечей, заготовка продуктов длительного хранения и др.
                </p>
                <p>
                    Проведение встреч с семьями участников СВО
                </p>
                <p>
                    Реализация культурно-просветительского направления по поддержке российских военнослужащих, находящихся 
                    на лечении и реабилитации. Проведение экскурсий по культурным объектам
                </p>
                <p>
                    Организация и поддержка всероссийских акций: «Тепло для героя», «СВОим героям» и др.
                </p>
            </div>
        </div>
    `
    },
]
